<h1 mat-dialog-title [innerHTML]="data.headline"></h1>
<mat-dialog-content class="mat-typography" [innerHTML]="'<p>' + data.message + '</p><span class=\'extra\'>' + (data.extra ? data.extra : '</span>')"></mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="clickOk()" [mat-dialog-close]="true" color="accent" class="btn small uppercase">Ok</button>
</mat-dialog-actions>